<template>
    <div class="share-here" v-if="isSectionVisible">
        <template v-if="isStorySubmitted">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <div class="text-danger">
                        <h4><strong>Thank you for sharing your story!</strong></h4>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <hr v-if="hr == 'above'"/>
            <div class="row">
                <div class="col-sm-12">
                    <h2>Every inscription has a story. Share yours here!</h2>
                </div>
                <div class="col-sm-3">
                    <form action="" class="info-form">
                        <div class="row">
                            <div class="col-sm-12" v-bind:class="{'has-error': errors.has('story.first_name') }">
                                <input type="text" class="form-control" placeholder="First Name"
                                    v-model="story.first_name"
                                    data-vv-name="story.first_name"
                                    v-validate="'required'"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12" v-bind:class="{'has-error': errors.has('story.last_name') }">
                                <input type="text" class="form-control" placeholder="Last Name"
                                   v-model="story.last_name"
                                   data-vv-name="story.last_name"
                                   v-validate="'required'"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12" v-bind:class="{'has-error': errors.has('story.phone') }">
                                <input type="tel"class="form-control" placeholder="Phone Number"
                                    v-model="story.phone"
                                    data-vv-name="story.phone"
                                    v-validate="'required|digits:10'"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12" v-bind:class="{'has-error': errors.has('story.email') }">
                                <input type="email" class="form-control" placeholder="Email Address"
                                    v-model="story.email"
                                    data-vv-name="story.email"
                                    v-validate="'required|email'"
                                />
                            </div>
                        </div>
                        <input type="hidden" name="order_id" v-model="order"/>
                    </form>
                </div>
                <div class="col-sm-9"> 
                    <form action="" class="info-form">
                        <textarea class="form-control" v-model="story.description"
                            placeholder="Enter your story here. Share with us the meaning behind your inscription or what Cal State Fullerton means to you. Your stories and photos can become a part of history that will never be forgotten!"
                        ></textarea>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <em class="text-small">
                        By submitting your story and related photos, you grant California State University, Fullerton, its affiliates and partners irrevocable permission to use your story and/or to create derivative works and/or adaptations of your story for marketing purposes, including, but not limited to social media, television, radio, and print marketing. Further, your submission of this form indicates your authorization for California State University, Fullerton to contact you for additional information.
                    </em>
                </div>
            </div>
            <div class="row" v-if="isUploadFailed">
                <div class="col-sm-12">
                    <div class="text-danger">
                        <p><strong>{{ errorMessage }}</strong></p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="text-left">
                        <label for="file-upload" class="btn btn-outline-danger pointer">Upload Photo</label>
                        <input id="file-upload" type="file" ref="file" accept="image/*" v-on:change="onFileChange"/>
                        <span v-if="file.isUploaded">
                            <i class="fa fa-picture-o"></i> {{ file.name }}
                        </span>
                        <span class="pull-right">
                            <a class="btn btn-default" v-on:click="onHide">No Thanks</a>
                            <a class="btn btn-danger" v-on:click.stop.prevent="onSubmit">Submit Story</a>
                        </span>
                    </div>
                </div>
            </div>
            <hr v-if="hr == 'below'"/>
        </template>
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'share-story',
        props: {
            hr: {
                required: true,
                type: String,
                default: 'above' // 'below' or 'none'
            },
            order: {
                required: false,
                type: String,
                default: ''
            }
        },
        data: function () {
            return this.getDefaultData();
        },
        methods: {
            getDefaultStory: function () {
                return {
                    form: new FormData(),
                    story: {
                        /**/
                        first_name: '',
                        last_name: '',
                        phone: '',
                        email: '',
                        description: ''
                        /**/
                        // DEBUG
                        /** /
                        first_name: 'Norma',
                        last_name: 'Baker',
                        phone: '5551234567',
                        email: 'njb@bollywood.com',
                        description: 'lorem ipsum dolor sit amet'
                        /**/
                    }
                }
            },
            getDefaultFile: function () {
                return {
                    file: {
                        isUploaded: false,
                        name: ''
                    }
                }
            },
            getDefaultData: function () {
                return {
                    isSectionVisible: true,
                    isStorySubmitted: false,
                    isUploadFailed: false,
                    errorMessage: '',
                    ...this.getDefaultStory(),
                    ...this.getDefaultFile()
                }
            },
            reset: function (update, keepStory = false) {
                var result = Object.assign({}, this.getDefaultFile());
                if (keepStory) {
                    Object.assign(result, { form: new FormData() });
                } else {
                    Object.assign(result, this.getDefaultStory());
                }
                Object.assign(this.$data, result, update || {});
                this.$validator.reset();
            },
            onFileChange: function (e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    return;
                }
                var fileName = files[0].name || false;
                if (fileName !== false) {
                    Object.assign(this.file, { isUploaded: true, name: fileName });
                    this.form.set('image', files[0], files[0].name);
                }
            },
            onHide: function () {
                this.reset({ isSectionVisible: false });
            },
            onFailure: function (body) {
                var update = { isUploadFailed: true, errorMessage: 'Story upload was failed. Please try again later.' };
                var data = body || {};
                var keepStory = false;
                var errors = 'errors' in data ? data.errors : {};
                if ('image' in errors) {
                    keepStory = true;
                    if ( typeof errors.image  === 'string') {
                        update.errorMessage = errors.image;
                    } else { // default message
                        update.errorMessage = 'Your image should be of .jpg, .gif, or .png file types and no more than two megabytes in size.';
                    }
                }
                this.reset(update, keepStory);
            },
            onSuccess: function () {
                this.reset({ isStorySubmitted: true });
            },
            onSubmit: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        /* global FRS_CAMPAIGN, FRS_API_HOST */
                        var endpoint = window.location.protocol + FRS_API_HOST + '/api/story/upload';
                        this.form.set('campaign', FRS_CAMPAIGN);
                        Object.keys(this.story).map((key) => {
                            this.form.set(key, this.story[key]);
                        });
                        if (+this.order > 0) {
                            this.form.set('order_id', this.order);
                        }
                        this.$http.post(endpoint, this.form, {
                            headers : {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then(function (response) {
                            var data = response.body || {};
                            var success = 'success' in data ? data.success : false;
                            if (success) {
                                this.onSuccess();
                            } else {
                                this.onFailure(data);
                            } 
                        }, function (error) {
                            console.log('Network error: ', error);
                            this.onFailure(error);
                        });
                    }
                }).catch(function (err) {
                    console.log('NEED to correct some errors first!' /* , err */);
                    this.onFailure(err);
                });
                return false;
            }
        }
    }
</script>

<style scoped>
    input[type="file"] {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// ShareStory.vue?b57efbe2